if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        pagination: '.swiper-pagination',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      // Deux usages coexistent :
      //   - sans data-items (bandeau categories) : largeur de slide libre,
      //     espacement fixe, pas de pagination. Comportement d'origine.
      //   - avec data-items (liste de collections) : nombre de colonnes par
      //     palier, espacement repris de la gouttiere de grille de la section,
      //     et pagination optionnelle.
      const hasColumns = typeof this.dataset.items !== 'undefined';
      const paginationType = this.dataset.paginationType;

      let slidesPerView = 'auto';
      let spaceBetween = 8;
      let breakpoints = { 768: { spaceBetween: 10 } };

      if (hasColumns) {
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--f-column-gap');
        spaceBetween = parseFloat(columnGap) * 10 || 12;
        slidesPerView = parseFloat(this.dataset.tabletItems) || 2;
        breakpoints = {
          768: { slidesPerView: parseFloat(this.dataset.tabletItems), spaceBetween: spaceBetween },
          1024: { slidesPerView: parseFloat(this.dataset.laptopItems), spaceBetween: spaceBetween },
          1280: { slidesPerView: parseFloat(this.dataset.items), spaceBetween: spaceBetween },
        };
      }

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
        slidesPerView: slidesPerView,
        spaceBetween: spaceBetween,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: paginationType
          ? { el: this.section.querySelector(this.selectors.pagination), type: paginationType }
          : false,
        loop: false,
        threshold: 2,
        breakpoints: breakpoints,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
